import { render, staticRenderFns } from "./MediaClaimSource.vue?vue&type=template&id=509b8a54&"
import script from "./MediaClaimSource.vue?vue&type=script&lang=js&"
export * from "./MediaClaimSource.vue?vue&type=script&lang=js&"
import style0 from "./MediaClaimSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports